import { render, staticRenderFns } from "./Templates.vue?vue&type=template&id=a0f59014&scoped=true"
import script from "./Templates.vue?vue&type=script&setup=true&lang=js"
export * from "./Templates.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Templates.vue?vue&type=style&index=0&id=a0f59014&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0f59014",
  null
  
)

export default component.exports